import type { MenuItem } from '@backmarket/http-api/src/api-specs-navigation-experience/navigation/sidebar'

import type { NavigationItem } from '../types'

export const SEASONAL_HIGHLIGHT_COLOR = '#9D3963'

export enum ItemType {
  CATEGORY = 'category',
  EVENT = 'event',
  GIFT = 'gift',
  GIFT_CARD = 'gift-cards',
  OUTLET = 'outlet',
  UNIVERSE = 'universe',
}

function getSeasonalHighlightColor(type: string): string | undefined {
  return type.toLowerCase() === ItemType.EVENT
    ? SEASONAL_HIGHLIGHT_COLOR
    : undefined
}

export function toUrl(
  locale: string,
  name: string,
  id: string,
  type: string,
): string {
  if (type.toLowerCase() === ItemType.EVENT) {
    return `/${locale}/e/${name}`
  }
  if (type.toLowerCase() === ItemType.OUTLET) {
    return `/${locale}/outlet`
  }
  if (
    type.toLowerCase() === ItemType.UNIVERSE ||
    type.toLowerCase() === ItemType.CATEGORY
  ) {
    return `/${locale}/l/${name}/${id}`
  }

  if (
    [ItemType.GIFT, ItemType.GIFT_CARD].includes(
      type.toLowerCase() as ItemType,
    ) &&
    name === 'home'
  ) {
    return `/${locale}/${type}`
  }

  return `/${locale}/${type}/${name}`
}

export function mapMenuItem(item: MenuItem, locale: string): NavigationItem {
  return {
    children: item.children?.map((child) => mapMenuItem(child, locale)) || [],
    id: item.id,
    image: item.imageUrl,
    title: item.title,
    url: toUrl(locale, item.name, item.id, item.type),
    details: item.meta?.map((meta) => meta.sidebar),
    icon: item.icon,
    type: item.type,
    color: getSeasonalHighlightColor(item.type),
  }
}
